export class AWPDownloadRequest {
    public documentId: number;
    public isInternalUser: boolean;
}